import { findCandidateReportDetails } from 'gql/query'

const createHeader = async (currentHeader: string[], userResultData: any) => {
  try {
    const updatedHeader: string[] = []
    const bloomHeader: string[] = []
    const reportThemeDetails = userResultData?.section_wise_report_theme_details
    for (const sectionWiseDetails of reportThemeDetails) {
      const sectionName = sectionWiseDetails?.section_name
      //creating section wise report theme header
      for (const reportTheme of sectionWiseDetails?.report_theme_details) {
        updatedHeader.push(`S_${sectionName}_RT_${reportTheme.name}`)
      }
    }
    for (const bloom of userResultData?.blooms_level_details?.labelsOfSection) {
      bloomHeader.push(`Bloom_${bloom}`)
    }
    const actualHeader = [...currentHeader, ...updatedHeader, ...bloomHeader]

    if (actualHeader.length > 0) {
      return { status: true, actualHeader }
    } else {
      return { status: false, message: 'Something went wrong!' }
    }
  } catch (err) {
    return { status: false, message: 'Something went wrong!' }
  }
}

const createData = async (candidateResult: any) => {
  try {
    const individualResults: any[] = []
    individualResults.push(
      candidateResult?.candidate_id,
      candidateResult?.candidate_name,
      candidateResult?.section_level_details?.test_track_name,
      candidateResult?.section_level_details?.test_date,
      candidateResult?.section_level_details?.total_marks,
      candidateResult?.national_average_details?.total_national_average
    )
    for (const reportThemeList of candidateResult?.section_wise_report_theme_details) {
      for (const reportTheme of reportThemeList.report_theme_details) {
        console.log(reportTheme?.markScored)
        let markScored = reportTheme?.markScored
        individualResults.push(markScored)
      }
    }
    individualResults.push(...candidateResult?.blooms_level_details?.sectionWiseTotalObtained)
    const row = await individualResults.toString().split(',')
    return row
  } catch (err) {
    console.log(err)
  }
}

export const candidateBulkReportGeneration = async (candidateDetailsArray: any) => {
  try {
    const candidateDetails = candidateDetailsArray.filter((item: any) => item?.application_id!== '')
    if (candidateDetails.length > 0) {
      const candidateResults: any = []
      const exportDataHeaders: string[] = ['Candidate ID', 'Candidate Name', 'Test Track', 'Test Date', 'Total Score', 'National Average']
      const exportData: any[] = []

      for (const obj of candidateDetails) {
        const candidateIndividualResultResponse: any = await findCandidateReportDetails(obj.application_id)
        let candidateIndividualResult = candidateIndividualResultResponse.candidate_report_data[0]
        if (candidateIndividualResult) {
          candidateResults.push(candidateIndividualResult)
        }
      }
      if (candidateResults.length !== candidateDetails.length) {
        return { status: false, message: 'Candidates results are missing. Please generate the results' }
      }
      const actualHeaderResponse = await createHeader(exportDataHeaders, candidateResults[0])
      if (!actualHeaderResponse?.status) {
        return actualHeaderResponse
      }
      const actualHeader = actualHeaderResponse?.actualHeader
      if (actualHeader) {
        exportData.push(actualHeader)
        for (const individualResult of candidateResults) {
          const row = await createData(individualResult)
          if (row && row.length > 0) {
            exportData.push(row)
          }
        }
        if (exportData.length > 1) {
          return { status: true, exportData }
        }
        return { status: false, message: 'Sorry, No data!' }
      }

      return { status: false, message: 'Something went wrong' }
    }
  } catch (err) {
    console.log(err)
    return { status: false, message: 'Something went wrong!' }
  }
}
